<script>
    export default {
        props: {
            share: {
                type: Object,
                default: null
            }
        },
        computed: {
            status() {
                if (this.share.download_failed_at) {
                    return 'failed';
                } else if (this.share.download_generated_at) {
                    return 'generated';
                } else if (this.share.download_started_at) {
                    return 'started';
                } else if (this.share.download_scheduled_at) {
                    return 'scheduled';
                } else {
                    return 'notscheduled';
                }
            },
        },
        methods: {
            download() {
                window.location.href = this.share.url;
            },
        }
    }
</script>
<template>
    <div class="package-download-button">
            <template v-if="status === 'notscheduled'">
                <a class="btn btn-sm btn-default disabled">
                    <i class="fa fa-stop fa-fw"></i>
                    {{ __('scoop-os.packages.status.'+status) }}
                </a>
            </template>
            <template v-else v-if="status === 'scheduled'">
                <a class="btn btn-sm btn-default disabled">
                    <i class="fa fa-pause fa-fw"></i>
                    {{ __('scoop-os.packages.status.'+status) }}
                </a>
            </template>
            <template v-else v-if="status === 'started'">
                <a class="btn btn-sm btn-default disabled">
                    <i class="fa fa-spinner fa-spin fa-fw"></i>
                    {{ __('scoop-os.packages.status.'+status) }}
                </a>
            </template>
            <template v-else v-if="status === 'generated'">
                <a @click="download" class="btn btn-sm btn-primary">
                    <i class="fa fa-cloud-download fa-fw"></i>
                    {{ __('scoop-os.packages.status.'+status) }}
                </a>
            </template>
            <template v-else v-if="status === 'failed'">
                <a class="btn btn-sm btn-default disabled">
                    <i class="fa fa-exclamation fa-fw"></i>
                    {{ __('scoop-os.packages.status.'+status) }}
                </a>
            </template>
    </div>
</template>